"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestCMD = void 0;
var RequestCMD;
(function (RequestCMD) {
    RequestCMD["ACTIVATE"] = "activate";
    RequestCMD["DEACTIVATE"] = "deActivate";
})(RequestCMD || (exports.RequestCMD = RequestCMD = {}));
